import { ThirdwebProvider } from "@thirdweb-dev/react";
import './App.css';
import { NavbarDefault } from './components/GlobalNavBar';
import Dashboard from './pages/providers/Dashboard';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';


import LandingPage from './components/LandingPage';
import { ProviderSignup, Signup } from './pages/providers/Signup';
import { AuthProvider } from "./context/AuthContext";
import PatientDashboard from "./pages/patients/PatientDashboard";
import { PatientSignup } from "./pages/patients/PatientSignup";
import { SignupNavbar } from "./components/SignupNavbar";

function App() {
  const isAuthenticated = () => {
    const token = localStorage.getItem('authToken');
    return !!token; // returns true if token exists, false otherwise
  };


  return (
    <div className="App">
      {/* To-do: Put the client id in an env file */}
      <AuthProvider>
        <ThirdwebProvider activeChain="localhost" clientId="46cea76e201f51800baccbcf003f856b" authConfig={{
        domain: "http://127.0.0.1:3001", // Replace with your actual domain
        authUrl: "/api/auth", // Replace with your actual auth endpoint
      }}>
          <Router>
            <SignupNavbar/>
            <Routes>
              <Route path="/" element={<LandingPage/>}> </Route>
              <Route 
          path="/patient-dashboard" 
          element={isAuthenticated() ? <PatientDashboard /> : <Navigate to="/" />} 
        />
        <Route 
          path="/dashboard" 
          element={isAuthenticated() ? <Dashboard /> : <Navigate to="/" />} 
        />
              {/* <Route path="/patient-dashboard" element={<PatientDashboard/>} /> */}
              <Route path="/dashboard" element={<Dashboard/>}/>
              <Route path="/signup" element={<PatientSignup/>}/>
              <Route path="/providers-signup" element={<ProviderSignup/>} />
            </Routes>
          </Router>
          
      </ThirdwebProvider>
    </AuthProvider>
      
    </div>
  );
}

export default App;
